import { randomSession } from 'common';
import { message } from 'antd';

function useResourceUpload() {
  const postToUploadResource = (
    file: any,
    fileType: string,
    callback: any = null
  ) => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('sessionId', randomSession());

    const url = `${alo7Api.prefix.host}/api/v1/resources_${
      alo7Nav.subject
    }?type=${fileType}`;
    alo7Api
      .fetch(url, {
        method: 'POST',
        body: formData,
        headers: { 'Content-Type': 'auto' },
      })
      .then((response: { uuid: string; url: string }) => {
        if (callback) callback(response.uuid);
      })
      .catch(error => {
        message.error(error.message);
      });
  };

  return { postToUploadResource };
}

export default useResourceUpload;
